import { render, staticRenderFns } from "./errorBook.vue?vue&type=template&id=32733318&scoped=true&"
import script from "./errorBook.vue?vue&type=script&lang=js&"
export * from "./errorBook.vue?vue&type=script&lang=js&"
import style0 from "./errorBook.vue?vue&type=style&index=0&id=32733318&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32733318",
  null
  
)

export default component.exports